import styled from 'styled-components'

export const DesktopCompareView = styled.div`

  .navigation-tabs {
    margin-bottom: 20px;
  }

  .compare-hint-box {
    background-color: ${ (props) => props.theme.colors['hintergrund-prio2'] };
    font-size: 18px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    border-radius: 4px;
    padding: 13px 15px 20px 15px;

    p {
      margin: 0;

      .searchTerm {
        font-weight: bold;
      }
    }

  }

  //container for all compare items
  .compare-container {
    flex-wrap: nowrap;

    &.loader {
      display: flex;
      justify-content: center;
      width: 100%;
    }

    &:not(.first) {
      .compare-item {
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    .compare-item {
      display: flex;
      justify-content: center;

      &.last-compare-item {
        margin-top: 30px;
      }
    }

    .detail-item {
      .compare-accordion {
        height: 100%;
        margin: 5px 0;
        box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, 0.13);

        .no-detail-data {
          padding: 30px 15px 10px;
        }
      }
    }


    * a {
      text-decoration: none;
    }

    // separate compare item (max three elements)
    .select-container {
      display: flex;
      flex-direction: column;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      width: 100%;

      * {
        color: ${ (props) => props.theme.colors['standard-schwarz'] };
      }

      .select-label {
        margin-bottom: 20px;
        font-size: 22px;
        line-height: 1.23;

      }

      .compare-select {
        position: relative;
        min-width: inherit;
        font-size: 18px;
        line-height: 1.39;
        width: 100%;

        // title element
        > span:first-child {
          > span > div {
            overflow-x: hidden;
            text-overflow: ellipsis;
          }
        }

        // option list
        > span:nth-child(2) {
          width: inherit;

          > ul > li {
            white-space: pre-wrap;
          }
        }
      }
    }

  }
}`
